import React from 'react';

import { sortMedia } from 'utils';
import MediaItemPreview from 'components/MediaItemPreview';

const MaterialMediaGrid = props => {
	const { event, linkType, library, media, handlePickItem } = props;
	const sortedMedia = sortMedia(media, library.sort_order);

	const renderMediaItem = (mediaItem, i) => (
		<MediaItemPreview
			key={i}
			index={i}
			mediaItem={mediaItem}
			linkType={linkType}
			library={library}
			eventID={event.id}
			handlePickItem={handlePickItem}
		/>
	);

	return (
		<div className={'media-thumbail-grid'}>
			{sortedMedia.map((mediaItem, i) => renderMediaItem(mediaItem, i))}
		</div>
	);
};

export default MaterialMediaGrid;
